class SearchJour {

	constructor() {
		this.init();
	}

	init() {
    $('#search-jour').on('keyup', function() {
      var value = $(this).val().toLowerCase();

      $('.search-jour').filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)

        if($(this).parent().find('.search-jour:visible').length){
          $(this).parent().find('.area').addClass('active');
        }else{
          $(this).parent().find('.area').removeClass('active');
        }
      });

      $('#jour-page #found').html($('.search-jour:visible').length);
			$('a.search-jour > span').css('display', 'block')
    });
	}
}

export default SearchJour;
